import React from "react";
import { useSelector } from "react-redux";
import "./Profile.css";

const Profile = () => {
  // Get user from Redux or fallback to localStorage
  const user = useSelector((state) => state.appstate.user) || JSON.parse(localStorage.getItem("user"));
  
  if (!user) {
    return (
      <div className="profile-page">
        <h2 className="no-user">Please login to view your profile</h2>
      </div>
    );
  }

  const initial = user.name ? user.name.charAt(0).toUpperCase() : "?";

  return (
    <div className="profile-page">
      <div className="profile-card">
        {/* Avatar */}
        <div className="avatar">{initial}</div>

        {/* Name & Email */}
        <h2 className="username">{user.name}</h2>
        <p className="user-email">{user.email}</p>

        {/* Divider */}
        <hr className="divider" />

        {/* Orders Section */}
        <div className="orders-section">
          <h3>Your Orders</h3>
          <div className="orders-placeholder">
            No orders yet. Your orders will appear here.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
